<template>
  <p-cascader
    @on-change="onChange"
    :value.sync="val"
    :change-on-select="changeOnSelect"
    :data="data"
    :trigger="trigger"
    :size="size"
    :clearable="clearable"
    :disabled="disabled"
    :render-format="renderFormat"
    :load-data="loadSubData"
    :placeholder="placeholder"
  ></p-cascader>
</template>

<script>
import Cascader from "../../standard/components/cascader";
import { getJSON } from "../common/utils";

export default {
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    size: {
      validator(value) {
        return oneOf(value, ["small", "large"]);
      }
    },
    trigger: {
      validator(value) {
        return oneOf(value, ["click", "hover"]);
      },
      default: "click"
    },
    renderFormat: {
      type: Function,
      default(label) {
        return label.join(" / ");
      }
    },
    changeOnSelect: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: "请选择类目"
    },
  },
  name: "Category",
  components: { Cascader },
  data() {
    return {
      val: [],
      data:[]
    };
  },
  compiled () {
    this.loadTopData();
  },
  watch:{
    value(val){
      this.val=[];
      if(!this.changeOnSelect){
        this.$nextTick(()=>{
            this.val=val;
        });
      }else{
        val[0]?this.val.push(val[0]):null;
      }
    }
  },
  methods: {
    loadTopData() {
      getJSON('https://product.7fresh.com/api/category/tree',"get").done(data => {
        this.data = data;
        if(!this.changeOnSelect){
          this.$nextTick(()=>{
            this.val=this.value;
          });
        }else{
          this.value[0]?this.val.push(this.value[0]):null;
        }
      });
    },
    loadSubData(item, callbackFunc) {
      getJSON(`https://product.7fresh.com/api/category/subtree/${item.id}`,"get").done(data => {
        item.loading = false;
        if (data.length == 0) {
          item.children = data;
          return false;
        }
        if (item.level == 3) {
          item.children = [];
          for (var i = 0; i < data.length; i++) {
            var temp = {};
            temp.label = data[i].label;
            temp.value = data[i].value;
            temp.id = data[i].id;
            item.children.push(temp);
          }
        } else {
          item.children = data;
        }
        callbackFunc();
        if(this.changeOnSelect){
          this.$nextTick(()=>{
            this.value[item.level]?this.val.push(this.value[item.level]):null;
          });
        }
        
      });
    },
    onChange(value, selectedData) {
      this.$emit("on-change", value, selectedData);
      if(this.changeOnSelect){
        this.$nextTick(()=>{
          this.val=value;
        });
      }
      this.value=value;
    }
  }
};
</script>



// WEBPACK FOOTER //
// category.vue?ac7327fe